<template>
    <div v-if="value" class="msg-group-wrapper">
        <div class="flex-center-hori">
            <div class="tips-top">您可以尝试这样问我</div>
        </div>
        <div class="msg-content-box tips-flex">
            <div v-for="tip in value.tips" :key="tip.prompt" class="tip-box" @click="$emit('fillText', tip)">
                <div class="tip-text">{{ tip.prompt }}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'MsgWelcomePrompt',
    props: {
        value: {
            type: Object,
            default: null
        }
    }
};
</script>
<style lang="scss" scoped>
.msg-group-wrapper {
    padding: 0 50px 0 60px;
}
.tips-top {
    margin: 16px 0;
    font-size: 16px;
    color: var(--msg-common-text-color);
    line-height: 24px;
    opacity: 0.45;
}

.tips-flex {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: space-between;

    >.tip-box {
        box-sizing: border-box;
        padding: 0 8px;
        height: 80px;
        width: calc(33% - 10px);
        background: var(--msg-welcome-prompt-bg);
        border-radius: 4px;
        opacity: 0.85;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        cursor: pointer;

        >.tip-text {
            margin: 0 6px;
            flex: 1 1 auto;
            font-size: 16px;
            color: var(--msg-common-text-color);
            line-height: 24px;
            text-align: center;
            overflow-wrap: break-word;
        }

        >.tip-arrow {
            width: 16px;
            flex: 0 0 auto;
            margin: 0 6px;
        }
    }
}

@media screen and (max-width: 580px) {
    .msg-group-wrapper {
        .tips-flex {
            display: inline-block;
            >.tip-box {
                padding: 16px;
                width: 100%;
                background: var(--msg-welcome-prompt-bg);
                margin-bottom: 24px;
            }
        }
    }
}
</style>
